import React from "react";

interface Props {
  level: 1 | 2 | 3 | 4;
  className?: string;
}

const BAR_HEIGHTS = ["h-[10px]", "h-[13px]", "h-[16px]", "h-[20px]"] as const;

/**
 * Wifi/signal-style complexity indicator — 4 ascending vertical bars.
 * Bars 1..level are filled (bg-signal), remainder are faint (bg-border-strong).
 * Used in the worklist case row in place of a raw finding count to discourage
 * cherry-picking by radiologists.
 */
export const ComplexityBars: React.FC<Props> = ({ level, className }) => (
  <div
    className={`flex items-end gap-[2px]${className ? ` ${className}` : ""}`}
    title="Case complexity"
    aria-label={`Case complexity ${level} of 4`}
  >
    {([1, 2, 3, 4] as const).map((i) => (
      <div
        key={i}
        data-testid="complexity-bar"
        data-filled={i <= level}
        className={`w-1 rounded-none ${BAR_HEIGHTS[i - 1]} ${
          i <= level ? "bg-signal" : "bg-border-strong"
        }`}
      />
    ))}
  </div>
);
